import { FunctionComponent, useState } from 'react';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';

import { Modal, ModalActions, ModalContent, useModal } from 'app/components';
import { useTriggerConfirmSwitchMutation } from 'app/hooks/useOrderQueries';
import { ErrorResponse, SwitchOrderFull } from 'app/types';
import { formatError } from 'app/utils/error-utils';

export const CeaseOfService: FunctionComponent<{ order: SwitchOrderFull }> = ({ order }) => {
  const { mutate, isLoading } = useTriggerConfirmSwitchMutation();
  const navigate = useNavigate();
  const { open, handleOpen, handleClose } = useModal();
  const [error, setError] = useState<ErrorResponse | undefined>();

  const handleSubmit = async () => {
    setError(undefined);

    mutate(
      {
        id: order.switchId
      },
      {
        onSuccess: () => {
          handleClose();
          navigate(0);
        },
        onError: err => {
          setError(formatError(err));
        }
      }
    );
  };

  return (
    <>
      <Button variant='contained' onClick={handleOpen}>
        Confirm Cease of Service
      </Button>

      <Modal
        modalTitle='Confirm Cease of Service'
        modalError={error}
        isOpen={open}
        onClose={handleClose}
      >
        <ModalContent>
          <Typography variant='body1'>
            You are confirming that the customer&apos;s services have
            <br />
            been ceased within your system.
          </Typography>
          <br />
          <Typography>Click confirm to continue.</Typography>
        </ModalContent>

        <ModalActions>
          <Button onClick={handleClose}>Close</Button>
          <Button
            data-testid='confirm'
            variant='contained'
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Confirm'}
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
